module.exports = __webpack_public_path__ + "static/media/gb-nir.ec252553.svg";